export type AdLinkType = "page" | "subscribe";
export const AD_LINK_TYPES: AdLinkType[] = ["page", "subscribe"];
export enum AdLinkTypes {
  PAGE = "page",
  SUBSCRIBE = "subscribe",
}
